// 用户登录才可用的块
const LOGIN_AVAILABLE_BLOCKS = [
    // iot blocks
    'iot.ifttt_pub',
    'iot.ifttt_recv',
    // 'iot.mqtt_pub',
    // 'iot.mqtt_recv',
    'iot.data_addtolist_cloudlist',
    'iot.data_itemoflist_cloudlist',
    'iot.data_lengthoflist_cloudlist',
    'iot.iot_connect_network',
    'iot.iot_if_connect_network',
    'iot.iot_air',
    'iot.iot_sun',
    'iot.iot_weather',

    // ai blocks
    'cognitive.beginSpeechToText',
    'cognitive.speechToTextResult',
    'cognitive.beginFaceDetection',
    'cognitive.faceDetectionResult',
    'cognitive.beginEmotionRecognition',
    'cognitive.emotionValue',
    'cognitive.emotionType',
    'cognitive.beginImageToText',
    'cognitive.beginHandwrittenToText',
    'cognitive.imageToTextResult',
];

const LOGIN_BLOCKS_BELONGTO_EXT = [
    'cognitive', 'iot'
];

export {
    LOGIN_AVAILABLE_BLOCKS,
    LOGIN_BLOCKS_BELONGTO_EXT
};